/**
 * Fintella gating rules for FRISCO processes.
 *
 * Shared by AddOrEditProcessComponent (certify link, Andes schema columns) and
 * FriscoUploadComponent (upload gate) so the conditions can't drift apart.
 */
import { PROCESS_KEYS } from './Constants';
import { getCustomAttribute } from '../utils/customAttributeUtils';

// The onboarding readiness attributes are written by the DE Glue create_schema
// job with sub_type 'FRISCO' (not 'FRISCO_PROCESS').
const FINTELLA_ATTRIBUTE_SUB_TYPE = 'FRISCO';

const FINTELLA_READY_ATTRIBUTES = {
    andesTableState: 'active',
    fintellaTableRegistrationState: 'registered',
    andesTableCreationStatus: 'true',
};

const getFintellaAttribute = (process, attributeType) =>
    getCustomAttribute(
        process,
        attributeType,
        FINTELLA_ATTRIBUTE_SUB_TYPE,
        PROCESS_KEYS.custom_attributes,
        PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS
    )[0];

/**
 * True when a process can be certified in Fintella: it is fintella_enabled,
 * its Andes table is fully onboarded (created + active, Fintella registration
 * registered), and it has a dataset to certify.
 */
export const isFintellaCertifiable = (process) =>
    !!process?.[PROCESS_KEYS.fintella_enabled]
    && Object.entries(FINTELLA_READY_ATTRIBUTES).every(
        ([attributeType, readyValue]) => getFintellaAttribute(process, attributeType) === readyValue
    )
    && !!process?.[PROCESS_KEYS.dataset_name];

/**
 * True when the Fintella classification step is done: the process is
 * certifiable AND classification has been marked complete. Gates both the
 * Data element / Data classification schema columns and file uploads.
 */
export const isFintellaClassificationCompleted = (process) =>
    isFintellaCertifiable(process) && !!process?.[PROCESS_KEYS.is_classification_completed];
